import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ScheduledDiscovery, TimeUnit, DiscoverySettings, DiscoveryMethod } from 'DiscoveryEngine.TS/Discovery';
import { IpScope } from 'DiscoveryEngine.TS/Core';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';

@Component({
    selector: 'sched-disc-config-scopes',
	templateUrl: './sched-disc-config-scopes.component.html',
	styleUrls: ['./sched-disc-config-scopes.component.scss']
})
export class SchedDiscConfigScopesComponent extends SchedDiscConfigComponentBase {

	public IncludeScope: UntypedFormControl;
	public ExcludeScope: UntypedFormControl;

	public IncludeCategories: string[];
	public ExcludeCategories: string[];

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);

		this.IncludeCategories = [];
		this.ExcludeCategories = [];

		this.BuildForm();
	}

	protected BuildForm(): void {
		let includeScope = "";
		let includeCategories: string[] = [];
		let excludeScope = "";
		let excludeCategories: string[] = [];

		if (this.Settings) {
			includeScope = this.Settings.IncludeScope.ToString();

			this.Settings.IncludeCategories.ForEach((catName: string) => {
				includeCategories.push(catName);
			}, this);

			excludeScope = this.Settings.ExcludeScope.ToString();

			this.Settings.ExcludeCategories.ForEach((catName: string) => {
				excludeCategories.push(catName);
			}, this);
		}

		this.IncludeScope = new UntypedFormControl(includeScope);
		this.IncludeCategories = includeCategories;
		this.ExcludeScope = new UntypedFormControl(excludeScope);
		this.ExcludeCategories = excludeCategories;

		this.SettingsForm = this.fb.group({
			IncludeScope: this.IncludeScope,
			ExcludeScope: this.ExcludeScope,
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
		this.BuildForm();
	}

	public onIncludeCategoriesChange(event): void {
		this.SettingsForm.markAsDirty();
	}

	public onExcludeCategoriesChange(event): void {
		this.SettingsForm.markAsDirty();
	}

	public applyTempChanges(): void {
		if (this.Settings) {
			this.SaveScope(this.Settings.IncludeScope, this.IncludeScope.value);

			this.Settings.IncludeCategories.Clear();
			this.IncludeCategories.forEach((catName: string) => {
				this.Settings.IncludeCategories.Add(catName);
			}, this);

			this.SaveScope(this.Settings.ExcludeScope, this.ExcludeScope.value);

			this.Settings.ExcludeCategories.Clear();
			this.ExcludeCategories.forEach((catName: string) => {
				this.Settings.ExcludeCategories.Add(catName);
			}, this);

			this.BuildForm();
			this.onApplyTempChanges();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Include/Exclude Scopes"];
	}

}
